import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '#pplx/frontend/aether/components/Badge/index.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const UpsellTierBadge = React.memo(function UpsellTierBadge({ requiredTier, }) {
    const { $t } = useIntl();
    const { isPro, isMax } = useIsSubscribed();
    const isLoggedIn = useIsUserLoggedIn();
    if (isMax) {
        return null;
    }
    if (isPro) {
        return (_jsx(Badge, { variant: "info", children: _jsx(FormattedMessage, { defaultMessage: "Max", id: "0573fe7c89", description: "Badge label for Max tier upsell" }) }));
    }
    if (isLoggedIn) {
        return (_jsx(Badge, { variant: "info", children: requiredTier === 'max'
                ? $t({
                    defaultMessage: 'Max',
                    id: '4594230951',
                    description: 'Badge label for Max users',
                })
                : $t({
                    defaultMessage: 'Pro',
                    id: '91e9a66940',
                    description: 'Badge label for Pro users',
                }) }));
    }
    return null;
});
//# sourceMappingURL=UpsellTierBadge.js.map